import LoginPage from "../views/LoginPage.vue";
const routes = [
  {
    path: "/",
    name: "Login",
    component: LoginPage,
  },
  {
    path: "/attendance",
    name: "Attendance",
    component: () => import("../views/Transaction/AttendancePage.vue"),
  },
];

export default routes;
